import * as React from 'react'
import ExceptionIssue from '../../model/ExceptionIssue'
import UnhandledException from '../../model/UnhandledException'
import { configuration } from '../../rest-api/Configuration'
import { Button, Card } from 'react-bootstrap'
import ErrorStackParser from 'error-stack-parser'
import StackTraceGPS from 'stacktrace-gps'

export interface StateProps {
  exceptionIssue?: ExceptionIssue
  error: string
  hasException: boolean
  exception?: UnhandledException
}

export interface DispatchProps {
  raiseException: (unhandled: UnhandledException) => Promise<ExceptionIssue>
  clearException: () => void
}

type Props = StateProps & DispatchProps

export class UnhandledExceptionHandlerComponent extends React.Component<Props, {}> {
  constructor(props: Props, context?: {}) {
    super(props, context)
    var me = this
    window.onerror = function(event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) {
      me.componentDidCatch(error)
    }
  }

  componentDidCatch(error?: Error) {
    var exception = new UnhandledException()
    exception.application = 'SMART 2.0'
    exception.assemblyName = 'N/A'
    exception.softwareID = 1340
    exception.repository = 'smart-2.0'
    exception.subRepository = undefined
    if (error) {
      exception.exceptionMessage = error.message
      exception.baseExceptionMessage = error.name
      if (error.stack) {
        var raiseException = this.props.raiseException;

        var stackFrames = ErrorStackParser.parse(error)

        var gps = new StackTraceGPS()
        var newFrames = new Array(stackFrames.length)
        var frameResolved = 0;
        var frameComplete = () => {
          frameResolved++
          if (frameResolved === stackFrames.length) {
            exception.callStack = 'Error: ' + error.message + "\n\tat " + newFrames.join("\n\tat ")
            raiseException(exception)
          }
        }
        stackFrames.forEach(function(stackFrame, i){
            gps.pinpoint(stackFrame).then(function(newFrame: string){
                newFrames[i] = newFrame
                frameComplete()
            }, function(){
                newFrames[i] = stackFrames[i].toString()
                frameComplete()
            })
        })
      } else {
        exception.callStack = 'Unknown Call Stack'
        this.props.raiseException(exception)
      }
    } else {
      exception.exceptionMessage = 'Unknown Error'
      exception.baseExceptionMessage = 'Unknown Error'
      exception.callStack = 'Unknown Call Stack'
      this.props.raiseException(exception)
    }
  }

  render() {
    if (this.props.hasException) {
      return (
        <Card className="alert alert-danger">
          <h1>Encountered an error: {this.props.exception && this.props.exception.exceptionMessage}</h1>
          {configuration.ExceptionAPI ? (
            this.props.exceptionIssue ? (
              this.props.exceptionIssue.IsNew ? (
                <div>
                  A new issue has been raised for this error at{' '}
                  <a href={this.props.exceptionIssue.Address} target="blank">
                    {this.props.exceptionIssue.Address}
                  </a>
                  , if possible please add a comment to expand on what you were doing when this
                  error occurred.
                </div>
              ) : (
                <div>
                  An existing issue already exists at{' '}
                  <a href={this.props.exceptionIssue.Address} target="blank">
                    {this.props.exceptionIssue.Address}
                  </a>
                  to track this issue, if possible please add a comment to expand on what you were
                  doing when this error occurred.
                </div>
              )
            ) : this.props.error === '' ? (
              <div>Reporting error... Please wait.</div>
            ) : (
              <div>
                <div>Unable to record issue: {this.props.error}</div>
                <div>
                  Please contact the SMART team at{' '}
                  <a href="mailto:smartsupport@res-group.com">smartsupport@res-group.com</a>.
                </div>
              </div>
            )
          ) : (
            <div>
              <div>
                This error was not recorded as this deployment of the application is not set up to
                record errors.
              </div>
              <div>
                Please contact the SMART team at{' '}
                <a href="mailto:smartsupport@res-group.com">smartsupport@res-group.com</a>.
              </div>
            </div>
          )}
          <Button onClick={this.props.clearException}>Attempt to recover</Button>
        </Card>
      )
    } else {
      return <div className="grow parent">{this.props.children}</div>
    }
  }
}
